import type { ReactNode } from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import { XClose } from "@untitledui/icons";

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}

export function Dialog({ open, onOpenChange, children }: DialogProps) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-black/50" />
        <RadixDialog.Content className="fixed z-50 bg-bg-primary shadow-xl inset-0 flex flex-col sm:inset-auto sm:left-1/2 sm:top-1/2 sm:w-full sm:max-w-2xl sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-xl sm:border sm:border-border-secondary p-6">
          {children}
          <RadixDialog.Close className="absolute right-4 top-4 rounded-md p-1 text-fg-quaternary hover:text-text-primary transition-colors">
            <XClose className="size-5" />
          </RadixDialog.Close>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}

export function DialogTitle({ children }: { children: ReactNode }) {
  return (
    <RadixDialog.Title className="text-lg font-semibold text-text-primary mb-1 pr-8">
      {children}
    </RadixDialog.Title>
  );
}

export function DialogDescription({ children }: { children: ReactNode }) {
  return (
    <RadixDialog.Description className="text-sm text-text-secondary mb-5">
      {children}
    </RadixDialog.Description>
  );
}
